import api from '../http';
import { AxiosResponse } from 'axios';
import { Chat } from '../models/chat';
import { SystemSettings } from '../models/settings';


export interface IGetChatsResponse {
    chats: Chat[]
}


export default class AdminService {
    static async getModeration(): Promise<AxiosResponse<IGetChatsResponse>> {
        return await api.get('admin/moderation');
    };

    static async getSystemSettings(): Promise<AxiosResponse<SystemSettings>> {
        return await api.get('admin/system/settings');
    };

    static async updateSystemSettings(moderation: "auto" | "manual"): Promise<AxiosResponse<{}>> {
        return await api.put('admin/system/settings', {moderation: moderation});
    };

    static async getChats(last_chat_id: number | null, only_active: boolean): Promise<AxiosResponse<IGetChatsResponse>> {
        return await api.get('admin/chat', {params: {last_chat_id: last_chat_id, only_active: only_active}});
    };

    static async updateChatState(chat_ids: number[], approve: boolean): Promise<AxiosResponse<{}>> {
        return await api.put('admin/moderation', {chat_id: chat_ids, approve: approve});
    };
};